import React from "react";
import Styled from "./SAPCategoryMenuStyles";

const SAPCategoryMenu = ({ categories, activeId, onSelect }) => {
  return (
    <Styled.Menu>
      {categories.map((category) => {
        const isActive = category.id === activeId;
        return (
          <Styled.MenuItem
            key={category.id}
            isActive={isActive}
            onClick={() => onSelect(category.id)}
          >
            <Styled.MenuIcon isActive={isActive}>
              <category.Icon />
            </Styled.MenuIcon>
            <Styled.MenuLabel isActive={isActive}>
              {category.label}
            </Styled.MenuLabel>
          </Styled.MenuItem>
        );
      })}
    </Styled.Menu>
  );
};

export default React.memo(SAPCategoryMenu);
